import type { commonTypes } from '@ltvco/refresh-lib/v1';

export const toJsDate = (
  date: commonTypes.Date | undefined | null
): Date | undefined => {
  if (!date) {
    return undefined;
  }

  const { year, month, day } = date.parsed ?? {};
  if (year != null && month != null) {
    return new Date(year, month - 1, day ?? 1);
  }

  const parsed = date.full ? new Date(date.full) : undefined;
  return parsed && !Number.isNaN(parsed.getTime()) ? parsed : undefined;
};

export const isWithinMonths = (
  date: commonTypes.Date | undefined | null,
  months: number,
  now: Date
): boolean => {
  const jsDate = toJsDate(date);
  if (!jsDate) {
    return false;
  }

  const cutoff = new Date(now);
  const day = cutoff.getDate();
  cutoff.setDate(1);
  cutoff.setMonth(cutoff.getMonth() - months);
  const daysInCutoffMonth = new Date(
    cutoff.getFullYear(),
    cutoff.getMonth() + 1,
    0
  ).getDate();
  cutoff.setDate(Math.min(day, daysInCutoffMonth));
  cutoff.setHours(0, 0, 0, 0);
  return jsDate >= cutoff && jsDate <= now;
};

export const yearsSince = (
  date: commonTypes.Date | undefined | null,
  now: Date
): number | undefined => {
  const jsDate = toJsDate(date);
  if (!jsDate) {
    return undefined;
  }

  const msPerYear = 1000 * 60 * 60 * 24 * 365.25;
  return (now.getTime() - jsDate.getTime()) / msPerYear;
};
